export default "__VITE_ASSET__teurmuSn__"